import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      title: 'Choose your bouquet',
      description: 'Browse our curated collection and select the perfect arrangement for your occasion',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          <path d="M8 12l2 2 4-4"/>
        </svg>
      ),
      color: '#FF6B6B'
    },
    {
      id: 2,
      title: 'Add a personal message',
      description: 'Write a heartfelt note that we\'ll include with your beautiful bouquet',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          <path d="M13 8H7"/>
          <path d="M17 12H7"/>
        </svg>
      ),
      color: '#4ECDC4'
    },
    {
      id: 3,
      title: 'We deliver it with care',
      description: 'Our expert florists hand-deliver your arrangement fresh and on time',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M1 3h15v13H1z"/>
          <path d="M16 8h4l3 3v5h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
          <path d="M9 12h6"/>
        </svg>
      ),
      color: '#45B7D1'
    }
  ];

  return (
    <section className="how-it-works" aria-label="How it works">
      <div className="how-it-works__container">
        <div className="how-it-works__header">
          <h2 className="how-it-works__title">How It Works</h2>
          <p className="how-it-works__subtitle">
            Getting beautiful flowers delivered is simple with our 3-step process
          </p>
        </div>

        <div className="how-it-works__steps">
          {steps.map((step, index) => (
            <div key={step.id} className="how-it-works__step">
              <div className="step__number">{step.id}</div>
              
              <div className="step__icon" style={{ '--step-color': step.color }}>
                {step.icon}
              </div>
              
              <div className="step__content">
                <h3 className="step__title">{step.title}</h3>
                <p className="step__description">{step.description}</p>
              </div>
              
              {/* {index < steps.length - 1 && (
                <div className="step__connector">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9,18 15,12 9,6"/>
                  </svg>
                </div>
              )} */}
            </div>
          ))}
        </div>

        <div className="how-it-works__cta">
          <button className="how-it-works__button">
            Start Your Order
          </button>
          <p className="how-it-works__guarantee">
            ✨ 7-day freshness guarantee • 🚚 Same-day delivery available
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
